import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { filter } from '@uirouter/angular';
import { DataService } from '../../services/data.service';
import {forEach} from "@angular/router/src/utils/collection";
import { LogService } from '../../services/log.service';


@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {

  modalRef: NgbModalRef;
  closeResult: any;

  @Input("filter") filter = {
    code_type: ['check-product', 'pre-check', 'redeem_coupon', 'check_coupon'],
    isCodeTypeApplied: false,
    isRatedApplied: false,
    isExternalDBApplied: false,
    isDateApplied: false
  };

  @Input("transactionsHistory") transactionsHistory = [];
  @Output() filterTransaction = new EventEmitter<object>();

  @ViewChild("filterModelContent") private filterModelContent: ElementRef;
  constructor(
    private modalService: NgbModal,
    private dataService: DataService,
    private logService: LogService
  ) {
  }

  ngOnInit() {
  }

  closeModal() {
    this.modalRef.close();
  }

  applyFilter() {
    this.checkFilterKeys();
    let temp = this.transactionsHistory;

    temp = this.filterByCode(temp);

    if (this.filter['isRatedApplied']) {
      temp = this.filterByRating(temp);
    }

    if (this.filter['isExternalDBApplied']) {
      temp = this.filterByExternalDB(temp);
    }

    if (this.filter['isDateApplied']) {
      temp = this.filterByDate(temp);
    }

    this.filterTransaction.emit({ "filterTransactions": temp, "filter": this.filter});
    this.logService.printLog('Final Temp Data', temp);
    this.closeModal();
  }


  checkFilterKeys() {
    this.logService.printLog("Filter selected - ", this.filter);
    if (this.filter.hasOwnProperty('coupon') || this.filter.hasOwnProperty('product') || this.filter.hasOwnProperty('notification')) {
      this.filter['isCodeTypeApplied'] = true;
    }

    if (this.filter.hasOwnProperty('externalDB')) {
      this.filter['isExternalDBApplied'] = true;
    }

    if (this.filter.hasOwnProperty('isRated')) {
      this.filter['isRatedApplied'] = true;
    }

    if (this.filter.hasOwnProperty('dateFrom') && this.filter.hasOwnProperty('dateTo')) {
      this.filter['isDateApplied'] = true;
    } else {
      this.filter['isDateApplied'] = false;
    }
  }

  filterByCode(temp) {

    const tempArr = [];

    this.filter['code_type'] = [];
    if (this.filter['coupon'] || !this.filter['isCodeTypeApplied']) {
      this.filter['code_type'].push('check_coupon');
      this.filter['code_type'].push('redeem_coupon');
    }

    if (this.filter['product'] || !this.filter['isCodeTypeApplied']) {
      this.filter['code_type'].push('check-product');
      this.filter['code_type'].push('pre-check');
    }

    if (this.filter['notification'] || !this.filter['isCodeTypeApplied']) {
      this.filter['code_type'].push('notification');
    }

    for (const x in temp) {
      if (this.filter['code_type'].includes(temp[x].code_type)) {
        tempArr.push(temp[x]);
      }
    }
    return tempArr;
  }

  filterByRating(temp) {
    const tempArr = [];

    for (const x in temp) {
      if (temp[x].save_ratings === this.filter["isRated"]) {
        tempArr.push(temp[x]);
      }
    }

    return tempArr;
  }

  filterByExternalDB(temp) {

    const tempArr = [];

    for (const x in temp) {
      if (temp[x].touch_externalDB === this.filter["externalDB"]) {
        tempArr.push(temp[x]);
      }
    }

    return tempArr;
  }

  filterByDate(temp) {
    const tempArr = [];

    const dateFrom = new Date();
    const dateTo = new Date();

    dateFrom.setFullYear(this.filter['dateFrom'].year, this.filter['dateFrom'].month - 1, this.filter['dateFrom'].day);

    dateTo.setFullYear(this.filter['dateTo'].year, this.filter['dateTo'].month - 1, this.filter['dateTo'].day);

    for (const x in temp) {
      const objDate = new Date(temp[x].touch_goldKey_date);

      if (objDate.getTime() >= dateFrom.getTime() && objDate.getTime() <= dateTo.getTime()) {
        tempArr.push(temp[x]);
      }
    }
    return tempArr;
  }

  resetFilter() {
    this.filter = {
      code_type: ['check-product', 'pre-check', 'redeem_coupon', 'check_coupon'],
      isCodeTypeApplied: false,
      isRatedApplied: false,
      isExternalDBApplied: false,
      isDateApplied: false
    };

    this.filterTransaction.emit({ "filterTransactions": this.transactionsHistory, "filter": this.filter});
    this.closeModal();
  }

  open() {
    this.modalRef = this.modalService.open(this.filterModelContent);
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/filter/filter.component.ts